import {Tooltip} from "antd";
import {formatDateForAmPmDisplay, formatDateNoTime} from "../../utils/friendlyDate";
import React from "react";
import {StatusView} from "../../pages/messages/StatusView";
import {formatPhoneNumber} from "../../utils/friendlyPhone";

interface DashboardPreviewRowProps {
    type: 'checkouts' | 'messages' | 'orders';
    row: any;
}

const DashboardPreviewRow = ({ type, row }: DashboardPreviewRowProps) => {
    if(type === 'checkouts') {
        return <div className="row flex">
            <div className="flex2"><Tooltip title={formatDateForAmPmDisplay(new Date(row.day))}>{formatDateNoTime(new Date(row.day))}</Tooltip></div>
            {/*<div className="flex1">{row.checkout_id}</div>*/}
            <div className="flex3">{row.full_name}</div>
            <div className="flex2">${row.price_usd}</div>
            {/*<div className="flex2">{row.messages_sent} Messages Sent</div>*/}
            <div className="flex2"><div className={`status ${row.status} ${row.status === "recoverable" && row.should_ignore ? 'ignored' : ''}`}>{row.status === "recoverable" && row.should_ignore ? 'Skipped' : row.status}</div></div>
            {/*<div className="flex2">{row.future_messages}</div>*/}
        </div>
    } else if(type === 'messages') {
        return <div className="row flex">
            <div className="flex3"><Tooltip title={formatDateForAmPmDisplay(new Date(row.day))}>{formatDateNoTime(new Date(row.created_at))}</Tooltip></div>
            <div className="flex3">{row.full_name}</div>
            <div className="flex5">{formatPhoneNumber(row.receiver_phone_number)}</div>
            <div className="flex1"><StatusView value={row.status} errorMessage={row.reason} /></div>
        </div>
    }
    return null;
}

export default DashboardPreviewRow;